"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.AppIconSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _LinkColumn = require("../LinkColumn/LinkColumn");
const AppIconSkeleton = exports.AppIconSkeleton = (0, _mui.styled)(_mui.Skeleton)(({
  theme
}) => ({
  transform: 'none',
  display: 'inline-block',
  margin: theme.spacing(1, 1),
  width: 35,
  height: 35,
  overflow: 'hidden'
}));
const Root = exports.Root = (0, _mui.styled)(_LinkColumn.LinkColumn, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['hideOnDesktop'])
})(({
  hideOnDesktop,
  theme
}) => ({
  textAlign: 'center',
  display: 'flex',
  flexFlow: 'column',
  alignItems: 'center',
  [theme.breakpoints.up('md')]: {
    display: hideOnDesktop ? 'none' : 'flex',
    margin: 'auto'
  }
}));